import { Injectable } from '@angular/core';
import { ParserService } from './parser.service';

@Injectable({
  providedIn: 'root',
})
export class MultiSelectParserService<
  T extends string = string,
> extends ParserService<T[]> {
  public parse(value: T[]): string {
    return value.join(',');
  }

  public unparse(value: string): T[] {
    return value ? (value.split(',') as T[]) : [];
  }
}
